import { AxiosResponse } from "axios";
import { useQuery } from "react-query";

import axios from "libs/Axios";
import { AxiosDefaultErrorEntity } from "types/api/Common/ErrorTypes";
import { ModelCatalogDashboardSearchResponse } from "types/api/Tenant/ModelCatalogTypes";

export const MODEL_CATALOG_QUERY_KEY = {
  DASHBOARD_SEARCH: "MODEL_CATALOG_DASHBOARD_SEARCH",
};

export function useSearchModelCatalogDashboards(query: string, enabled = true) {
  return useQuery<
    AxiosResponse<ModelCatalogDashboardSearchResponse>,
    AxiosDefaultErrorEntity
  >(
    [MODEL_CATALOG_QUERY_KEY.DASHBOARD_SEARCH, query, 0, 50],
    () =>
      axios
        .get("/api/v1/model-catalog/dashboards/search", {
          params: { query, page: 0, size: 50 },
        })
        .then((response) => response),
    { enabled: enabled && Boolean(query.trim()) }
  );
}
